import * as React from 'react';

import { useApolloClient } from '@apollo/client';

import {
  GetAvailabilityAndPriceQueryBatchedQuery,
  GetAvailabilityAndPriceQueryBatchedQueryVariables,
} from '@notino/shared/definitions/types';

import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import getAvailabilityAndPriceQueryBatched from './queries/getAvailabilityAndPriceQueryBatched.graphql';

export const useGetProductByIds = () => {
  const { query } = useApolloClient();
  const { swogoIgnoreConvertedPrice } = useFeatureFlags();

  return React.useCallback(
    async (productIds: Array<string | number>) =>
      query<
        GetAvailabilityAndPriceQueryBatchedQuery,
        GetAvailabilityAndPriceQueryBatchedQueryVariables
      >({
        query: getAvailabilityAndPriceQueryBatched,
        variables: {
          ids: productIds.map(String),
        },
        fetchPolicy: 'cache-first',
      })
        .then((res) => res.data.vpProductByIds.filter(Boolean))
        .then((products) =>
          products.map(({ recommendedPrice, ...rest }) => ({
            ...rest,
            recommendedPrice:
              swogoIgnoreConvertedPrice && recommendedPrice?.isConverted
                ? null
                : recommendedPrice,
          }))
        ),
    [query, swogoIgnoreConvertedPrice]
  );
};
